import React, { useState, useEffect } from 'react'
import { Box, Textarea, Flex, Group, Button } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { updateOrderSummary } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'

const defaultVal = {
  sales_note: ''
}

const FormAdjustOrderNote = ({ idOrder, onCloseModal }) => {
  const dispatch = useDispatch()
  const { summary } = useSelector(state => state.order_detail)
  const [loadingForm, setLoadingForm] = useState(false)
  const [formData, setFormData] = useState(defaultVal)

  const submitUpdateOrder = async (form) => {
    setLoadingForm(true)
    try {
      const response = await updateOrder(idOrder, form)
      if (response.success) {
        onCloseModal()
        const updatedSummary = {
          ...summary,
          salesNote: response.data.attributes.sales_note
        }
        dispatch(updateOrderSummary(updatedSummary))
        notificationSuccess('Update Order Successfully', 'This data has been updated')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    handleSetState(summary)
  }, [summary])

  const handleSetState = (value) => {
    const detail = {
      sales_note: value.salesNote
    }
    setFormData(detail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }


  return (
    <Box>
      <Box mb='md'>
        <Textarea
          name='sales_note'
          label="Sales Order / Quote Note"
          value={formData.sales_note}
          onChange={(val) => handleChangeForm(`sales_note`, val.target.value)}
          size='xs'
          autosize
          minRows={6}
          maxRows={6}
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitUpdateOrder(formData)}>Update</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustOrderNote